// @flow strict
/* eslint-disable ta-code-conventions/has-matching-test,ta-code-conventions/has-matching-storydoc */

import * as React from 'react';

import useLogin from '@ta/login.login';
import { useGARecorder } from '@ta/platform.interactions';

/**
 * Props for passing in analytics data
 */
export type MemberHardGateProps = {|
  /** Product ID */
  pid?: number,

  /**
   * Tracking Module to use for the GA Record
   */
  trackingModule: string,

  /**
   * Indicates if we're in the control slice group
   */
  isControl: boolean,
|};

/**
 * Login gate for member gating. Disables the action in read-only mode
 */
const MemberHardGate = ({ pid, isControl, trackingModule }: MemberHardGateProps) => {
  const trackEvent = useGARecorder();

  React.useEffect(() => {
    trackEvent({
      module: trackingModule,
      action: 'member_gate_mounted',
    });
  }, [trackingModule, trackEvent]);

  const authGate = useLogin();

  React.useEffect(() => {
    if (!isControl) {
      authGate({
        pid,
        flowOrigin: 'join',
        flow: 'MEMBER_GATE_COMBINED',
        closeX: false,
        closeOnDocClick: false,
        windowShadeOption: 'light',
      });
    }
  }, [authGate, pid, isControl]);

  return null;
};

MemberHardGate.defaultProps = {
  pid: -1,
  trackingModule: 'memx_hard_gate',
  isControl: false,
};

export default MemberHardGate;
